var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":`tags-${_vm._uid}`},domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{staticClass:"tags-field",attrs:{"name":`tags-${_vm._uid}`,"id":`tags-${_vm._uid}`,"placeholder":_vm.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }